module.exports = __webpack_public_path__ + "img/27.db01528e.jpg";